import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchWelcomeVersion, fetchAppConfig } from './welcome-api';

export const fetchWelcome = createAsyncThunk('welcome/fetchData', async () => {
    const response = await fetchWelcomeVersion();
    return response.data;
});
export const fetchApp = createAsyncThunk('welcome/fetchAppConfig', async () => {
    const response = await fetchAppConfig();
    return response.data;
});
